export const INTENTION_NAMES = {
  NO_SALES_PRODUCER: 'NO_SALES_PRODUCER',
  NO_SALES_PRODUCER_LOW_POTENTIAL: 'NO_SALES_PRODUCER_LOW_POTENTIAL',
  NO_SALES_PRODUCER_MEDIUM_POTENTIAL: 'NO_SALES_PRODUCER_MEDIUM_POTENTIAL',
  INFLUENCER_PRODUCER: 'INFLUENCER_PRODUCER',
  NO_PRODUCT_PRODUCER_ABANDONED: 'NO_PRODUCT_PRODUCER_ABANDONED',
  SEED_PRODUCER: 'SEED_PRODUCER',
  BEGINNER_PRODUCER_MEDIUM_POTENTIAL: 'BEGINNER_PRODUCER_MEDIUM_POTENTIAL',
  BEGINNER_PRODUCER_HIGH_POTENTIAL: 'BEGINNER_PRODUCER_HIGH_POTENTIAL',
  BEGINNER_PRODUCER: 'BEGINNER_PRODUCER',
  BEGINNER_PRODUCER_LOW_POTENTIAL: 'BEGINNER_PRODUCER_LOW_POTENTIAL',
  SMALL_PRODUCER: 'SMALL_PRODUCER',
  MEDIUM_LARGE_PRODUCER: 'MEDIUM_LARGE_PRODUCER',
  PRODUCER_ABANDONED: 'PRODUCER_ABANDONED',
  UNDEFINED: 'UNDEFINED',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER',
  AFFILIATE: 'AFFILIATE',
  CURIOUS: 'CURIOUS'
}
